import React from "react";
import { Link } from "react-router-dom";

export default function Topbar() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <header
      data-testid="site-masthead"
      className="fixed top-0 left-0 right-0 z-50 bg-[#FF5B17] border-b-2 border-[#0A0A0A]"
    >
      <div className="max-w-[1500px] mx-auto px-5 lg:px-8 h-14 flex items-center justify-between text-[#0A0A0A]">
        <Link
          to="/"
          data-testid="masthead-logo"
          className="font-display text-2xl tracking-tight"
        >
          R⋆TAMA
        </Link>

        <nav className="hidden md:flex items-center gap-7 font-mono text-[10px] uppercase tracking-[0.2em]">
          <button
            data-testid="nav-platforms"
            onClick={() => scrollTo("platforms")}
            className="hover:underline underline-offset-4 decoration-2"
          >
            ① Platforms
          </button>
          <button
            data-testid="nav-services"
            onClick={() => scrollTo("services")}
            className="hover:underline underline-offset-4 decoration-2"
          >
            ② Services
          </button>
          <button
            data-testid="nav-worldwide"
            onClick={() => scrollTo("worldwide")}
            className="hover:underline underline-offset-4 decoration-2"
          >
            ③ Worldwide
          </button>
          <button
            data-testid="nav-contact"
            onClick={() => scrollTo("contact")}
            className="hover:underline underline-offset-4 decoration-2"
          >
            ④ Contact
          </button>
        </nav>

        <button
          data-testid="nav-cta-button"
          onClick={() => scrollTo("contact")}
          className="inline-flex items-center gap-2 bg-[#0A0A0A] text-[#FAF5E8] px-4 py-1.5 rounded-full font-mono text-[10px] uppercase tracking-[0.25em] hover:bg-[#FAF5E8] hover:text-[#0A0A0A] transition-colors"
        >
          Pitch us ↗
        </button>
      </div>
    </header>
  );
}
